<!--
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-03-12 16:41:37
-->
<template>
  <div class="wrapper">
    <p class="title">{{title}}</p>
    <div class="content">
      <span>{{minites}}</span>
      <label>分</label>
      <span>{{seconds}}</span>
      <label>秒</label>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    count: { type: Number, default: 0 },
    title: { type: String, default: '距离比赛开始' }
  },
  data () {
    return {
      timer: null,
      countDown: 0,
      minites: '00',
      seconds: '00'
    }
  },
  watch: {
    count (val) {
      if (val === 0) {
        return
      }
      this.countDown = this.count
      this.formateTimesZh(this.countDown)
      this.timeOutHandler()
    }
  },
  mounted () {
    if (this.count === 0) {
      return
    }
    this.countDown = this.count
    this.formateTimesZh(this.countDown)
    this.timeOutHandler()
  },
  methods: {
    timeOutHandler () {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        if (this.countDown <= 0) {
          clearInterval(this.timer)
          this.$emit('timeIsOvered')
          return
        }
        this.countDown -= 1
        this.formateTimesZh(this.countDown)
      }, 1000)
    },
    formateTimesZh (times) {
      const minites = Math.floor(times / 60)
      const seconds = Math.floor(times % 60)
      this.minites = String(minites).padStart(2, '0')
      this.seconds = String(seconds).padStart(2, '0')
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>
<style scoped lang='scss'>
.wrapper {
  border-radius: 4px;
  border: 1px solid #F04037;
  padding: 27px 20px;

}
.title {
  margin: 0;
  font-size: 16px;
  color: #F04037;
  text-align: center;
  margin-bottom: 10px;
}

.content {
  text-align: center;
  span {
    font-size: 46px;
    font-weight: bold;
  }
  label {
    font-weight: normal;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/time-out/index.vue